import { AccountType } from "@ctypes";
import { FiveTwoNineDisclaimer } from "./FiveTwoNineDisclaimer";
import { IRADisclaimer } from "./IRADisclaimer";

export const content: Record<AccountType, JSX.Element | null> = {
  [AccountType.Cash]: null,
  [AccountType.Corporate]: null,
  [AccountType.FiveTwoNinePlan]: <FiveTwoNineDisclaimer />,
  [AccountType.GeneralInvesting]: null,
  [AccountType.Individual]: null,
  [AccountType.Individual_529]: <FiveTwoNineDisclaimer />,
  [AccountType.IraRoth]: <IRADisclaimer />,
  [AccountType.IraSep]: <IRADisclaimer />,
  [AccountType.IraTraditional]: <IRADisclaimer />,
  [AccountType.Joint]: null,
  [AccountType.JuniorIraRoth]: <FiveTwoNineDisclaimer />,
  [AccountType.JuniorRothIra]: <FiveTwoNineDisclaimer />,
  [AccountType.RothIra]: <IRADisclaimer />,
  [AccountType.TraditionalIra]: <IRADisclaimer />,
  [AccountType.CustodialRothIra]: null,
  [AccountType.HarvestUtmaUgma]: null,
  [AccountType.Reserve]: null,
};
